import { useId } from 'react';

export function FigmaLogo({ className }: { className?: string }) {
  const clipId = useId();

  return (
    <svg width="80" height="80" viewBox="0 0 80 80" className={className} role="img">
      <title>Figma logo</title>
      <rect width="80" height="80" rx="20" fill="black" />
      <rect
        x="0.666667"
        y="0.666667"
        width="78.6667"
        height="78.6667"
        rx="19.3333"
        stroke="white"
        strokeOpacity="0.1"
        strokeWidth="1.33333"
      />
      <g clipPath={`url(#${clipId})`}>
        <path
          fill="#0ACF83"
          d="M32.484 61.98a7.174 7.174 0 0 0 7.17-7.171v-7.171h-7.17a7.174 7.174 0 0 0-7.171 7.17 7.174 7.174 0 0 0 7.17 7.172Z"
        />
        <path
          fill="#A259FF"
          d="M25.313 40.466a7.174 7.174 0 0 1 7.17-7.17h7.172v14.341h-7.171a7.174 7.174 0 0 1-7.171-7.17Z"
        />
        <path
          fill="#F24E1E"
          d="M25.313 26.124a7.174 7.174 0 0 1 7.171-7.17h7.171v14.341h-7.17a7.174 7.174 0 0 1-7.172-7.17Z"
        />
        <path
          fill="#FF7262"
          d="M39.655 18.953h7.171a7.174 7.174 0 0 1 7.171 7.171 7.174 7.174 0 0 1-7.171 7.171h-7.171V18.953Z"
        />
        <path
          fill="#1ABCFE"
          d="M53.997 40.466a7.174 7.174 0 0 1-7.171 7.171 7.174 7.174 0 0 1-7.171-7.17 7.174 7.174 0 0 1 7.171-7.172 7.174 7.174 0 0 1 7.171 7.171Z"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="28.69" height="43.0264" fill="white" transform="translate(25.31 18.9532)" />
        </clipPath>
      </defs>
    </svg>
  );
}
